import { InjectionToken } from '@angular/core';

export const KROS_IDENTITY_SERVER_CONFIG = new InjectionToken<KrosIdentityServerConfig>('KROS_IDENTITY_SERVER_CONFIG');

export class KrosIdentityServerConfig {
  clientUrl: string;
  url: string;
  applicationId?: string;
  externalLoginRoutes?: string[];
  postLogoutUrl?: string;
  deviceRegisterUrl?: string;
  deviceUpdateUrl?: string;

  /**
   * For apps usable without a login: losing the session only drops the user instead of redirecting to
   * the identity server. Explicit `startAuthentication()` / `logOut()` still redirect.
   */
  optionalAuthentication?: boolean;
}
